var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowclockwise28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1267 8.50003C20.739 7.99892 20.2917 7.53079 19.7851 7.1057C15.9775 3.91068 10.3007 4.40734 7.10564 8.21501C3.91062 12.0227 4.40727 17.6995 8.21495 20.8945C12.0226 24.0895 17.6994 23.5929 20.8944 19.7852C21.4269 19.1506 22.3731 19.0678 23.0077 19.6003C23.6423 20.1328 23.7251 21.0789 23.1926 21.7135C18.9325 26.7904 11.3635 27.4527 6.28658 23.1926C1.20969 18.9326 0.547481 11.3635 4.8075 6.28664C9.06752 1.20975 16.6366 0.547542 21.7135 4.80756C22.26 5.26618 22.7559 5.76374 23.2001 6.29291V4.00003C23.2001 3.1716 23.8717 2.50003 24.7001 2.50003C25.5285 2.50003 26.2001 3.1716 26.2001 4.00003V10C26.2001 10.8285 25.5285 11.5 24.7001 11.5H18.7001C17.8717 11.5 17.2001 10.8285 17.2001 10C17.2001 9.1716 17.8717 8.50003 18.7001 8.50003H21.1267Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowclockwise28);
export default __webpack_public_path__ + "static/media/arrow.clockwise_28.00f73347.svg";
export { ForwardRef as ReactComponent };